// First module of the prebuilt client: React Refresh follows React from its start, so the separately compiled
// prototype bundle can refresh its components in place. The bundle does not inject React Refresh again.
import { injectIntoGlobalHook } from "react-refresh/runtime"

declare global {
  var $RefreshReg$: () => void
  var $RefreshSig$: () => <T>(type: T) => T
}

injectIntoGlobalHook(globalThis)
// Modules that were not compiled for React Refresh still find its registration functions.
globalThis.$RefreshReg$ = () => {}
globalThis.$RefreshSig$ = () => (type) => type
